import RequestedItemAddedEvent from '@/domains/milestones/events/RequestedItemAddedEvent';
import RequestedItemDeletedEvent from '@/domains/milestones/events/RequestedItemDeletedEvent';
import RequestedItemUpdatedEvent from '@/domains/milestones/events/RequestedItemUpdatedEvent';

export const RequestedItemEvents = {
  Added: RequestedItemAddedEvent,
  Updated: RequestedItemUpdatedEvent,
  Deleted: RequestedItemDeletedEvent,
};
